import { CartApi } from '@linktivity/ars-neo';
import config from './config';

const cartApi = new CartApi(config);

export default cartApi;
